import React, { createContext, useContext, useEffect } from "react";
import About from "./components/About";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Contact from "./components/Contact";
import { useDarkMode } from "./hooks/useDarkMode";
import { initGA, trackEngagement } from "./utils/analytics";

// Crear contexto para el dark mode
export const DarkModeContext = createContext();

// Hook personalizado para usar el contexto
export const useDarkModeContext = () => {
  const context = useContext(DarkModeContext);
  if (!context) {
    throw new Error(
      "useDarkModeContext debe usarse dentro de DarkModeProvider",
    );
  }
  return context;
};

function App() {
  const darkMode = useDarkMode();

  // Inicializar Google Analytics
  useEffect(() => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (measurementId) {
      initGA(measurementId);
    } else {
      console.warn(
        "⚠️ Google Analytics no configurado. Agrega REACT_APP_GA_MEASUREMENT_ID al .env",
      );
    }

    // Rastrear engagement cada 30 segundos
    let timeSpent = 0;
    const interval = setInterval(() => {
      timeSpent += 30;
      trackEngagement(timeSpent);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <DarkModeContext.Provider value={darkMode}>
      {/* Navbar independiente y fijo */}
      <Navbar />
      {/* Contenedor principal con padding-top para compensar navbar fijo */}
      <div className="pt-[80px] bg-slate-50 dark:bg-slate-900 transition-colors duration-300">
        <Home />
        <About />
        <Skills />
        <Work />
        <Contact />
      </div>
    </DarkModeContext.Provider>
  );
}

export default App;
